import { HttpErrorsInterceptor } from './interceptors/http-errors.interceptor';
import { UserProfileModule } from './component/user-profile/user-profile.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EntityDataModule } from '@ngrx/data';
import { environment } from '../environments/environment';
import { metaReducers, reducers } from './reducers';
import { RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';
import { EffectsModule } from '@ngrx/effects';
import { AuthModule } from './component/auth/auth.module';
import { UrlProviderService } from './service/urlprovider.service';
import { WorkBenchModule } from './component/work-bench/work-bench.module';
import { MaterialModule } from './material/material.module';
import { CommonComponentsModule } from './component/common-components/common-components.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { PipesModule } from './pipes/pipes.module';
import { PartyModule } from './component/party/party.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
//import { MatPaginator } from '@angular/material/paginator';
//import { MatPaginatorModule } from '@angular/material/paginator';
//import { MatPaginatorModule } from '@angular/material/paginator';
import { MomentModule } from 'ngx-moment';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { NavigationModule } from './component/navigation/navigation.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { MsinInterceptorService } from './service/msin-interceptor.service';
import { SearchSchoolDistrictsComponent } from './component/system/school-districts/search-school-districts/search-school-districts.component';
import { SearchByComponent } from './component/school/search-by-layer/search-by-layer.component';
import { MsinMatTableComponent } from './component/school/msin-mat-table/msin-mat-table.component';
import { MsinMatTableDistrictsComponent } from './component/system/school-districts/msin-mat-table-districts/msin-mat-table-districts.component';
import { SearchSchoolsComponent } from './component/school/search-schools/search-schools.component';
import { SearchLocationLayerComponent } from './component/school/search-location-layer/search-location-layer.component';
import { SearchByDistrictsLayerComponent } from './component/system/school-districts/search-by-districts-layer/search-by-districts-layer.component';
import { DistrictsLocationLayerComponent } from './component/system/school-districts/districts-location-layer/districts-location-layer.component';
// import { SystemSchoolsComponent } from './component/system/system-schools/system-schools.component';
//import { SystemComponent } from './component/system/system/system.component';
import { HTMLCompressionService } from './service/htmlcompression.service';
import { FooterComponent } from './component/footer/footer.component';
//import { BackupPackageService } from 'src/app/service/backupPackageService.service';

@NgModule({
    declarations: [
        AppComponent,
        SearchByComponent,
        MsinMatTableComponent,
        SearchSchoolsComponent,
        SearchLocationLayerComponent, // --
        SearchByDistrictsLayerComponent,
        MsinMatTableDistrictsComponent,
        SearchSchoolDistrictsComponent,
        DistrictsLocationLayerComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        MatInputModule,
        MatDialogModule,
        MatDatepickerModule,
        MatNativeDateModule,
        PipesModule,
        AuthModule.forRoot(),
        WorkBenchModule.forRoot(),
        CommonComponentsModule.forRoot(),
        UserProfileModule.forRoot(),
        PartyModule.forRoot(),
        NavigationModule.forRoot(),
        StoreModule.forRoot(reducers, {
            metaReducers,
            runtimeChecks: {
                strictStateImmutability: true,
                strictActionImmutability: true,
                strictActionSerializability: true,
                strictStateSerializability: true,
                strictActionWithinNgZone: true,
                strictActionTypeUniqueness: true
            }
        }),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
            connectInZone: true
        }),
        EffectsModule.forRoot([]),
        EntityDataModule.forRoot({}),
        StoreRouterConnectingModule.forRoot({
            stateKey: 'router',
            routerState: RouterState.Minimal
        }),
        NgIdleKeepaliveModule.forRoot(),
        MomentModule,
        FooterComponent
    ],
    providers: [
        UrlProviderService,
        HTMLCompressionService,
        DatePipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: MsinInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorsInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
export class AppModule {}
